import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = (params = {}) =>
  api.get("/products", { params }).then((r) => r.data);

export const fetchProduct = (id) =>
  api.get(`/products/${id}`).then((r) => r.data);

export const fetchCategories = () =>
  api.get("/products/categories").then((r) => r.data);

export const createProduct = (data) =>
  api.post("/products", data).then((r) => r.data);

export const updateProduct = (id, data) =>
  api.put(`/products/${id}`, data).then((r) => r.data);

export const deleteProduct = (id) =>
  api.delete(`/products/${id}`).then((r) => r.data);

export const fetchOrders = () => api.get("/orders").then((r) => r.data);

export const fetchNeweggGuide = () =>
  api.get("/newegg/integration-guide").then((r) => r.data);

export const createOffer = (data) => api.post("/offers", data).then((r) => r.data);
export const fetchOffers = (params = {}) =>
  api.get("/offers", { params }).then((r) => r.data);
export const acceptOffer = (id, note = "") =>
  api.put(`/offers/${id}/accept`, { note }).then((r) => r.data);
export const rejectOffer = (id, note = "") =>
  api.put(`/offers/${id}/reject`, { note }).then((r) => r.data);
export const counterOffer = (id, counter_price, note = "") =>
  api.put(`/offers/${id}/counter`, { counter_price, note }).then((r) => r.data);
export const deleteOffer = (id) => api.delete(`/offers/${id}`).then((r) => r.data);
export const offerCheckout = (offerId, originUrl) =>
  api
    .post(`/offers/${offerId}/checkout`, { offer_id: offerId, origin_url: originUrl })
    .then((r) => r.data);

export const previewNeweggUrl = (url) =>
  api.post("/admin/preview-newegg", { url }).then((r) => r.data);
export const importNeweggUrl = (url) =>
  api.post("/admin/import-newegg", { url }).then((r) => r.data);
export const bulkImportNewegg = (url, limit = 10) =>
  api.post("/admin/bulk-import-newegg", { url, limit }).then((r) => r.data);

// ============== TRACKER ==============
export const fetchTrackedLinks = () =>
  api.get("/admin/tracker/links").then((r) => r.data);
export const addTrackedLink = (url, label = "") =>
  api.post("/admin/tracker/links", { url, label }).then((r) => r.data);
export const deleteTrackedLink = (id) =>
  api.delete(`/admin/tracker/links/${id}`).then((r) => r.data);
export const bulkDeleteTrackedLinks = (ids) =>
  api.post("/admin/tracker/links/bulk-delete", { ids }).then((r) => r.data);
export const updateTrackedLink = (id, patch) =>
  api.patch(`/admin/tracker/links/${id}`, patch).then((r) => r.data);
export const checkSingleLink = (id) =>
  api.post(`/admin/tracker/links/${id}/check`).then((r) => r.data);
export const uploadTrackerExcel = (file) => {
  const form = new FormData();
  form.append("file", file);
  return api
    .post("/admin/tracker/upload-excel", form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const trackerCheckNow = () =>
  api.post("/admin/tracker/check-now").then((r) => r.data);
export const fetchTrackerHistory = (linkId = null, limit = 100) =>
  api
    .get("/admin/tracker/history", { params: { link_id: linkId, limit } })
    .then((r) => r.data);
export const fetchTrackerSettings = () =>
  api.get("/admin/tracker/settings").then((r) => r.data);
export const updateTrackerSettings = (notify_email) =>
  api.put("/admin/tracker/settings", { notify_email }).then((r) => r.data);
export const fetchTrackerLastRun = () =>
  api.get("/admin/tracker/last-run").then((r) => r.data);
export const telegramDetect = () =>
  api.get("/admin/tracker/telegram/detect").then((r) => r.data);
export const setTelegramChatId = (chat_id) =>
  api.put("/admin/tracker/telegram/chat-id", { chat_id }).then((r) => r.data);
export const setTelegramGroupChatId = (chat_id) =>
  api.put("/admin/tracker/telegram/group-chat-id", { chat_id }).then((r) => r.data);
export const testTelegram = () =>
  api.post("/admin/tracker/telegram/test").then((r) => r.data);
export const sendTelegramReport = (forceRefresh = false) =>
  api
    .post(`/admin/tracker/telegram/report?force_refresh=${forceRefresh}`)
    .then((r) => r.data);

export const createCheckoutSession = (items, originUrl, customerEmail) =>
  api
    .post("/checkout/session", {
      items,
      origin_url: originUrl,
      customer_email: customerEmail,
    })
    .then((r) => r.data);

export const checkCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

// ============== STOCK WATCH ==============
export const fetchStockWatches = () =>
  api.get("/admin/stock-watch").then((r) => r.data);
export const createStockWatch = (data) =>
  api.post("/admin/stock-watch", data).then((r) => r.data);
export const updateStockWatch = (id, patch) =>
  api.patch(`/admin/stock-watch/${id}`, patch).then((r) => r.data);
export const deleteStockWatch = (id) =>
  api.delete(`/admin/stock-watch/${id}`).then((r) => r.data);
export const fetchStockWatchSettings = () =>
  api.get("/admin/stock-watch/settings").then((r) => r.data);
export const updateStockWatchSettings = (interval_minutes) =>
  api.put("/admin/stock-watch/settings", { interval_minutes }).then((r) => r.data);
export const fetchAutoBuy = () => api.get("/admin/stock-watch/auto-buy").then((r) => r.data);
export const updateAutoBuy = (data) => api.put("/admin/stock-watch/auto-buy", data).then((r) => r.data);
export const testAutoBuy = () => api.post("/admin/stock-watch/auto-buy/test").then((r) => r.data);
export const stockWatchTestTelegram = () =>
  api.post("/admin/stock-watch/test-telegram").then((r) => r.data);
export const stockWatchCheckNow = (ids = []) =>
  api.post("/admin/stock-watch/check-now", { ids }).then((r) => r.data);
